import React, { Component } from "react";
import { Redirect, Route, Switch } from "react-router";
import { connect } from "react-redux";
import { Header } from "../header/header";
import { Users } from "../users/users";
import { AddUser } from "../users/adduser";
import { Dashboard } from "../dashboard/dashboard";
import "./workarea.scss";
import { Row, Col } from "react-bootstrap";
import PowerBIReport from "../powerbi-report/powerbi-report";
import { AuthenticateService } from "../../security/login/authenticate.service";

class WorkAreaComponent extends Component<any, any> {
  renderRoutes() {
    const headerLinks = AuthenticateService.getHeaderLinks();
    const user = AuthenticateService.getActiveUser();
    const forceChangePassword = user ? user.passwordExpired : false;
    return (
      <>
        {headerLinks.map((link: any, index: any) => {
          return (
            <Route key={`ws-route-hl-${index}`} path={link.link}>
              <PowerBIReport
                id={link.functionId}
                config=""
                title={link.caption}
              ></PowerBIReport>
            </Route>
          );
        })}
        <Route key={`ws-route-1`} path="/administration" component={Users} />
        <Route key={`ws-route-2`} path="/users/new" component={AddUser} />
        <Route key={`ws-route-3`} path="/user/:userId" component={AddUser} />
        {headerLinks.length > 0 && !forceChangePassword ? (
          <Route key={`ws-route-4`} exact path="/">
            <Redirect to={headerLinks[0].link} />
          </Route>
        ) : (
          <Route key={`ws-route-4`} path="/" component={Dashboard}></Route>
        )}
      </>
    );
  }

  render() {
    return (
      <div id="main_content">
        <Row>
          <Col xs={12}>
            <Header></Header>
          </Col>
        </Row>
        <Row>
          <Col xs={12} className="pad-0">
            <Switch>{this.renderRoutes()}</Switch>
          </Col>
        </Row>
      </div>
    );
  }

  static properties = (state: any) => {
    return {
      user: state.app.user,
      connection: state.app.connection,
    };
  };

  static dispatchers = (dispatch: any) => {
    return {};
  };
}

export const WorkArea = connect(
  WorkAreaComponent.properties,
  WorkAreaComponent.dispatchers,
)(WorkAreaComponent);
